<app-compatibility-card>
  <h3>{{ "compatibility.equipment.title" | translate }}</h3>
  <h4>{{ "compatibility.equipment.subtitle" | translate }}</h4>
  <div class="buttons-wrapper">
    <button
      *ngFor="let machineType of firstLine$ | async"
      class="btn"
      (click)="onSelectEquipment(machineType.id)"
      [class.active]="(selectedEquipment$ | async) === machineType"
    >
      <span class="icon" [ngClass]="machineType.icon"></span>
      <span>{{ machineType.name | translate }}</span>
    </button>
  </div>
  <div class="buttons-wrapper">
    <button
      *ngFor="let machineType of secondLine$ | async"
      class="btn"
      (click)="onSelectEquipment(machineType.id)"
      [class.active]="(selectedEquipment$ | async) === machineType"
    >
      <span class="icon" [ngClass]="machineType.icon"></span>
      <span>{{ machineType.name | translate }}</span>
    </button>
  </div>
  <div class="buttons-wrapper">
    <button
      *ngFor="let machineType of thirdLine$ | async"
      class="btn"
      (click)="onSelectEquipment(machineType.id)"
      [class.active]="(selectedEquipment$ | async) === machineType"
    >
      <span class="icon" [ngClass]="machineType.icon"></span>
      <span>{{ machineType.name | translate }}</span>
    </button>
  </div>
</app-compatibility-card>
